class RelatedProductsSlider extends HTMLElement {
  constructor() {
    super();
    this.swiperInstance = null;
    this.observer = null;
  }

  connectedCallback() {
    if (!('IntersectionObserver' in window)) {
      this.init();
      return;
    }
    this.observer = new IntersectionObserver(
      (entries, obs) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.init();
            obs.unobserve(this);
          }
        });
      },
      { rootMargin: '200px' }
    );
    this.observer.observe(this);
  }

  disconnectedCallback() {
    if (this.observer) this.observer.disconnect();
    if (this.swiperInstance) {
      this.swiperInstance.destroy(true, true);
      this.swiperInstance = null;
    }
  }

  init() {
    if (typeof Swiper === 'undefined') {
      const start = Date.now();
      const poll = setInterval(() => {
        if (typeof Swiper !== 'undefined') {
          clearInterval(poll);
          this._build();
        } else if (Date.now() - start > 5000) {
          clearInterval(poll);
        }
      }, 50);
      return;
    }
    this._build();
  }

  _build() {
    const swiperEl = this.querySelector('.swiper');
    if (!swiperEl) return;

    this.swiperInstance = new Swiper(swiperEl, {
      slidesPerView: 1.3,
      spaceBetween: 16,
      loop:true,
      watchOverflow: true,
      breakpoints: {
        750: { slidesPerView: 2.2, spaceBetween: 16 },
        990: { slidesPerView: 3.2, spaceBetween: 16 },
      },
    });
  }
}

if (!customElements.get('related-products-slider')) {
  customElements.define('related-products-slider', RelatedProductsSlider);
}